import React, { useState, useEffect } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import ClientAttendanceReport from "./DayCareReports/ClientAttendanceReport";
import DailyAttendanceSummary from "./DayCareReports/DailyAttendanceSummary";
import EmployeeSessionsReport from "./DayCareReports/EmployeeSessionsReport";
import SessionsReport from "./DayCareReports/SessionsReport";

export default function Scheduler_Reports(props) {
    const [activeKey, setActiveKey] = useState("clientAttendance");

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    useEffect(() => {
        setActiveKey(props.activeSubKey)
    }, [props.activeSubKey]);

    return (
        <div style={{ width: '100%', position: 'absolute' }}>
            <div>
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                        fontFamily: "Lato",
                        marginBottom: 10,
                        marginLeft: 10
                    }}
                >
                    Schedule Management Reports
                </Typography>
            </div>
            <div style={{ width: '100%' }}>
                <Tabs
                    value={activeKey}
                    onChange={handleKeyChange}
                    variant="scrollable"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                        },
                        width: 'inherit'
                    }}
                >
                    {props.user.permissions.ClientAttendanceReport && <Tab key={"clientAttendance"} value={"clientAttendance"} label="Client Attendance" />}
                    {props.user.permissions.DailyAttendanceSummary && <Tab key={"dailyAttendance"} value={"dailyAttendance"} label="Daily Attendance Summary" />}
                    {props.user.permissions.EmployeeSessionsReport && <Tab key={"employeeSessions"} value={"employeeSessions"} label="Employee Sessions" />}
                    {<Tab key={"sessions"} value={"sessions"} label="Sessions Report" />}
                </Tabs>

                <div style={{ width: '100' }}>
                    {activeKey === "clientAttendance" && <ClientAttendanceReport {...props} />}
                    {activeKey === "dailyAttendance" && <DailyAttendanceSummary {...props} />}
                    {activeKey === "employeeSessions" && <EmployeeSessionsReport {...props} />}
                    {activeKey === "sessions" && <SessionsReport {...props} />}
                </div>
            </div>
        </div>
    )
};